module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "toc"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/OnceAMarine_foreword#foreword"
    }
  }, [_vm._v("Foreword by Colonel Bryan McCoy, USMC")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/OnceAMarine_collaborator#collaborator"
    }
  }, [_vm._v("Collaborator’s Note: Working with Gunny Pop")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/OnceAMarine_introduction#introduction"
    }
  }, [_vm._v("Introduction and Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/OnceAMarine_part1#part1"
    }
  }, [_vm._v("PART 1: Bang—I’m Not Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/OnceAMarine_part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2: Making This Marine")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/OnceAMarine_epilogue#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Tip of the Spear")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d6ba095","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnceAMarine_toc.vue
// module id = 69
// module chunks = 0